import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild, ViewEncapsulation, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription, Observable, forkJoin, of } from 'rxjs';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { ILLCompany, ICompanyDetail, ILLCustomerCompaniesByTypeWrapper, ILLGenericKeys } from '../../../../shared/models';
import { LLFormService, CompanyContactService, StorageManagerService } from '../../../../shared/services';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { ToastrService } from 'ngx-toastr';
import { RefdataService } from '../../../../shared/services/refdata.service';
import { catchError } from 'rxjs/operators';
import { CompanyDetailsComponent } from '../../../index';

@Component({
  selector: 'app-ll-form-labeler',
  templateUrl: './ll-form-labeler.component.html',
  styleUrls: ['./ll-form-labeler.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class LLFormLabelerComponent implements OnInit, AfterViewInit, OnChanges {

  labelerForm: UntypedFormGroup;
  labeler: ILLCompany = new ILLCompany();
  labelerCompanies: ILLCompany[] = [];
  companyNdcCodes: ILLGenericKeys[] = [];
  lCompanyRevisionId: any;
  companyDataSource: any[] = [];
  ndcDataSource: any[] = [];
  ndcType = 'multi';
  ndcLabelerCode: string;
  modalWidth = '450px';

  // dialog settings
  isModal = true;
  animationSettings: Object = { effect: 'Zoom' };
  hide: any;
  position: object = { X: 'center', Y: 'center' };
  target = '#modalTarget';
  visible = true;
  compHidden = false;
  ndcHidden = false;
  hidden: Boolean = false;

  @Input() llFormData: any;
  @Input() prodIndex: number;
  @Input() canCreateCompany: boolean;
  @Output() labelerCodeValue = new EventEmitter<any>();

  @ViewChild('confirmDialogCompany')
  public confirmDialogCompany: DialogComponent;

  @ViewChild('confirmDialogNDC')
  public confirmDialogNDC: DialogComponent;

  ddwHeight = '220px';
  waterMark = 'Select one';
  companyFields: Object = { text: 'name', value: 'id' };

  @ViewChild('lCompanyDdw') companyDdw: DropDownListComponent;

  ndcFields: Object = { text: 'name' };
  @ViewChild('ndcDdw') ndcDdw: DropDownListComponent;

  @ViewChild('companyDialog') public companyDialog: DialogComponent;
  @ViewChild('companyDetails') public companyDetailsComponent: CompanyDetailsComponent;

  labelerCompanyCodeChangedObject = {};
  ndcCodeChangedObject = {};
  ndcUserLabelerCodeBeforeSelectionChanged: any;
  missingLabelerError = false;
  iconTypeCompany = true;
  isCompanyInactive = false;
  inactiveLabelerContactName: string;
  sub: Subscription;
  companyToViewRevisionId: number;
  parentComponent: any;
  customerGuid: string;
  companyData: any;

  ndcProductCodeChangedObject = {};
  company$: Observable<ICompanyDetail> | null;

    constructor(private fb: UntypedFormBuilder, private llFormService: LLFormService, private toastr: ToastrService,
      private companyService: CompanyContactService, private cdref: ChangeDetectorRef,
    private refDataService: RefdataService, private storageManagerService: StorageManagerService) { }

  confirmDlgButtonsCompanyBtnClickYes: EmitType<object> = () => {
    if (this.confirmDialogCompany) {

      this.confirmDialogCompany.hide();
      
      this.ndcUserLabelerCodeBeforeSelectionChanged = this.labelerForm.value.userNdcLabelerCode;

      this.lCompanyRevisionId = this.labelerCompanyCodeChangedObject['newLabelerCompanyId'];
      this.setNDCddw(this.lCompanyRevisionId);
      this.ndcLabelerCode = '';
      this.ndcDdw.value = '';


      this.setChangedLabelerCompany();

      this.labelerCodeValue.emit('');
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    for (const property in changes) {

      if (changes[property].currentValue) {

        switch (property) {
          case 'lCompanyRevisionId':
            this.enablePrivateNdcInput();
            break;
          case 'ndcUserLabelerCodeBeforeSelectionChanged':

            break;
        }
      }
    }
  }

  setChangedLabelerCompany() {

    this.setNDCddw(this.lCompanyRevisionId);
    this.llFormData[0].data.labelerCompanyRevisionId = this.lCompanyRevisionId;

    this.labelerForm.patchValue({
      lCompanyRevisionId: this.lCompanyRevisionId
    });

    if (!this.labelerForm.value.userNdcLabelerCode && this.ndcType !== 'single' ) {

      this.labelerCodeValue.emit(this.ndcLabelerCode ? this.ndcLabelerCode :  (this.ndcDataSource && this.ndcDataSource.length ? (this.ndcDataSource[1] ? this.ndcDataSource[1]['name'] : '') : ''));

      if (this.ndcType === 'multi') {
        if (this.ndcDdw) {
          this.ndcDdw.value = this.ndcLabelerCode ? this.ndcLabelerCode :  (this.ndcDataSource && this.ndcDataSource.length ? (this.ndcDataSource[1] ? this.ndcDataSource[1]['name'] : '') : '');
        }
      }
      this.labelerForm.patchValue({

        ndcLabelerCode: this.ndcLabelerCode ? this.ndcLabelerCode :  (this.ndcDataSource && this.ndcDataSource.length ? (this.ndcDataSource[1] ? this.ndcDataSource[1]['name'] : '') : '')
      });

    } else {

      this.labelerCodeValue.emit(this.labelerForm.value.userNdcLabelerCode);

      this.labelerForm.patchValue({
        lCompanyRevisionId: this.lCompanyRevisionId,
        userNdcLabelerCode: this.labelerForm.value.userNdcLabelerCode
      });
    }
    const changedCompany = this.labelerCompanies.find(c => c.companyRevisionId === this.lCompanyRevisionId);

    if (changedCompany) {
      this.llFormData[0].data.labelerCompany = changedCompany;
    }

    this.enablePrivateNdcInput();
  }

  enablePrivateNdcInput() {

    if (this.lCompanyRevisionId) {

      const privateNdc = document.getElementById('ndcSingle');

    if (privateNdc) {
      privateNdc.removeAttribute('disabled');
      this.missingLabelerError = false;
    }
    }
  }

  confirmDlgButtonsCompanyBtnClickNo: EmitType<object> = () => {

    if (this.confirmDialogCompany) {

      this.confirmDialogCompany.hide();

    }

    this.ndcUserLabelerCodeBeforeSelectionChanged = this.labelerForm.value.userNdcLabelerCode;

    this.lCompanyRevisionId = this.labelerCompanyCodeChangedObject['oldLabelerCompanyId'];

    this.ndcDdw.value = this.ndcLabelerCode ? this.ndcLabelerCode : (this.ndcDataSource[1] ? this.ndcDataSource[1]['name'] : '');

    this.labelerForm.patchValue({
      lCompanyRevisionId: this.labelerCompanyCodeChangedObject['oldLabelerCompanyId'],
      ndcType: this.ndcType,
      ndcLabelerCode: this.ndcLabelerCode
    });

    this.labelerCompanyCodeChangedObject = {};
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  confirmDlgButtonsCompany: Object[] = [{ click: this.confirmDlgButtonsCompanyBtnClickNo.bind(this), buttonModel: { content: 'Cancel' } }, { click: this.confirmDlgButtonsCompanyBtnClickYes.bind(this), buttonModel: { content: 'Continue', isPrimary: true } }];

  ngOnInit() {

    this.labelerForm = this.fb.group({
      lCompanyRevisionId: ['', { updateOn: 'blur' }],
      ndcLabelerCode: ['', { updateOn: 'blur' }],
      userNdcLabelerCode: ['', { updateOn: 'blur' }],
      ndcType: ['multi', { updateOn: 'blur' }]
    });

    this.setCompaniesDdw();

    // Watches changes on the entire form
    this.labelerForm.valueChanges.subscribe(data => {

      this.lCompanyRevisionId = data['lCompanyRevisionId'];
      this.llFormService.llFormLabelerSubject.next(this.labelerForm.value);
    });

    if (this.llFormData) {

      if (this.llFormData[0] && this.llFormData[0].data) {

        this.labeler = this.llFormData[0].data['labelerCompany'];
        this.lCompanyRevisionId = this.labeler.companyRevisionId;
        this.ndcLabelerCode = this.llFormData[0].data.ndcLabelerCode ? this.llFormData[0].data.ndcLabelerCode : this.labeler.ndcLabelerCode;

        this.setNDCddw(this.lCompanyRevisionId);

        this.enablePrivateNdcInput();
      }
    }

    this.parentComponent = this;

    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');


  if (currentCustomerStr) {
    const currentCustomer = JSON.parse(currentCustomerStr);
    if (currentCustomer) {
      this.customerGuid = currentCustomer.customerGuid;
    }
    }

    this.patchForm();

    // Check if previously saved company are not the latest revision, display warning message
    this.isCompanyLatest(this.labelerCompanies, this.labeler.companyRevisionId);
  }
  patchForm() {

    this.labelerForm.patchValue({
      lCompanyRevisionId: this.labelerCompanyCodeChangedObject ? this.labelerCompanyCodeChangedObject['oldLabelerCompanyId'] : this.labeler.companyRevisionId,
      ndcLabelerCode: this.labeler.ndcLabelerCode ? this.labeler.ndcLabelerCode : this.ndcCodeChangedObject['oldNdcCode']
    });

      this.setNDCddw(this.labeler.companyRevisionId);
  }

  ngAfterViewInit(): void {

    if (this.llFormData && this.llFormData[0].data ) {

      this.labeler = this.llFormData[0].data.labelerCompany;
      this.lCompanyRevisionId = this.labeler.companyRevisionId;

      if (this.lCompanyRevisionId) {

        this.companyDdw.value = this.lCompanyRevisionId;

        if (this.ndcLabelerCode) {

          this.ndcDdw.value = this.ndcLabelerCode;
        } else {

          this.ndcDdw.value = (this.ndcDataSource[0] && this.ndcDataSource[0].length > 0) ? this.ndcDataSource[0]['name'] : '';
        }
      }

      const formNdcCode = this.llFormData[0].data.ndcLabelerCode;
      let privateCode;

      if (formNdcCode) {
        privateCode = this.labeler.ndcLabelerCodes.filter(n => n.label === formNdcCode).length === 0;
      }

      if (this.lCompanyRevisionId > 0 && privateCode) {
        this.labelerForm.patchValue({
          ndcType: 'single',
          userNdcLabelerCode: formNdcCode
        });

        this.ndcLabelerCode = formNdcCode;

        this.ndcDdw.value = formNdcCode;
      }

      this.labelerForm.patchValue({
        lCompanyRevisionId: this.labeler.companyRevisionId
       });

      this.llFormService.llFormLabelerSubject.next(this.labelerForm.value);
    }
  }

  setCompaniesDdw() {

    if (this.llFormData && this.llFormData[2].data) {

      const companyTypes: ILLCustomerCompaniesByTypeWrapper = this.llFormData[2].data;
      this.labelerCompanies = companyTypes.labelers;
    }

    if (this.labelerCompanies && this.labelerCompanies.length > 0) {

      this.labelerCompanies.forEach((company: ILLCompany) => {

        const ds = { id: 0, name: '' };
        ds.id = +company.companyRevisionId;
        ds.name = company.companyName;

        this.companyDataSource.push(ds);
      });
    }
  }

  setNDCddw(companyRevisionId: number) {

    this.ndcDataSource = [];

    if (companyRevisionId && this.labelerCompanies && this.labelerCompanies.length > 0) {

      const company = this.labelerCompanies.find((c: ILLCompany) => c.companyRevisionId === companyRevisionId);

      if (company) {

          const ndcCodes: ILLGenericKeys[] = company.ndcLabelerCodes;
        this.ndcDataSource.push({ name: '' });

        if (ndcCodes && ndcCodes.length && ndcCodes[0].label) {

          ndcCodes.forEach((element: ILLGenericKeys) => {

            const ds = { name: '' };
            ds.name = element.label;
            this.ndcDataSource.push(ds);
          });
        }

        this.ndcLabelerCode = this.llFormData[0].data.ndcLabelerCode ? this.llFormData[0].data.ndcLabelerCode : (this.ndcDataSource[1] ? this.ndcDataSource[1]['name'] : '');

        this.labelerForm.patchValue({
          lCompanyRevisionId: this.lCompanyRevisionId,
          ndcLabelerCode: this.ndcType === 'multi' ? this.ndcLabelerCode : ''
        });
      } else {

        // means the company has been updated outside of the LL form.
        // set the labeler code from the form.
        const formLabeler = this.llFormData[0].data.labelerCompany;

        let ndcCodes: ILLGenericKeys[] = formLabeler.ndcLabelerCodes;

        if (formLabeler.ndcLabelerCodes && formLabeler.ndcLabelerCodes.length) {
          ndcCodes = ndcCodes.filter(c => c.code.toLowerCase() === 'active');
        }

        this.ndcDataSource.push({ name: '' });

        if (ndcCodes && ndcCodes.length && ndcCodes[0].label) {

          ndcCodes.forEach((element: ILLGenericKeys) => {

            const ds = { name: '' };
            ds.name = element.label;
            this.ndcDataSource.push(ds);
          });
        }
        if (this.ndcLabelerCode) {
          this.ndcDataSource = this.ndcDataSource.filter( c => c.name === this.ndcLabelerCode);
        } else {

          const ndcProductCode = this.llFormData[0].data.products[0].ndcProductCode;
          const productLabelerCode = ndcProductCode.split('-').length ? ndcProductCode.split('-')[0] : '';

          this.ndcLabelerCode = this.llFormData[0].data.ndcLabelerCode ? this.llFormData[0].data.ndcLabelerCode : (productLabelerCode ? productLabelerCode : '');
        }

        this.llFormData[0].data.ndcLabelerCode = this.ndcLabelerCode;

        this.labelerForm.patchValue({
          lCompanyRevisionId: this.lCompanyRevisionId,
          ndcLabelerCode: this.ndcType === 'multi' ? this.ndcLabelerCode : ''
        });
      }
    }
  }

  lCompanySelectionChanged(event) {

    this.missingLabelerError = false;

    if (event.isInteracted) {

      this.labelerCompanyCodeChangedObject = { oldLabelerCompanyId: event.previousItemData ? event.previousItemData.id : '', newLabelerCompanyId: event.value };

      if (this.labelerCompanyCodeChangedObject['oldLabelerCompanyId']) {
        this.confirmDialogCompany.show();
      } else {

        this.setChangedLabelerCompany();
      }

      this.labelerForm.markAsDirty();
    }

    this.enablePrivateNdcInput();
  }

  ndcRadioChanged(event) {

    this.ndcType = this.ndcType === 'multi' ? 'single' : 'multi';

    if (event.value === 'single') {

      if (!this.lCompanyRevisionId) {
        this.missingLabelerError = true;
      }

      this.ndcLabelerCode = '';

      this.labelerForm.patchValue({
        ndcType: 'single',
        userNdcLabelerCode: '',
        ndcLabelerCode: ''
      });
    } else {

      this.ndcUserLabelerCodeBeforeSelectionChanged = '';

      this.labelerForm.patchValue({
        ndcType: 'multi',
        ndcLabelerCode: '',
        userNdcLabelerCode: ''
      });
    }

    this.labelerForm.markAsDirty();
  }

  lNdcSelectionChanged(event) {

    if (event.isInteracted) {

      this.confirmDialogNDC.show();

      this.ndcLabelerCode = event.value ? event.value : 'xxxx' ;

      this.ndcCodeChangedObject = { oldNdcCode: event.previousItemData ? event.previousItemData.name : '', newNdcCode: this.ndcLabelerCode };

      this.ndcType = 'multi';

      this.labelerForm.patchValue({
        ndcType: 'multi',
        userNdcLabelerCode: ''
      });

      this.ndcUserLabelerCodeBeforeSelectionChanged = '';
    }
  }

  privateNdcCodeKeyUp(event) {

    this.ndcType = 'single';

    this.labelerForm.patchValue({
      ndcType: 'single',
      ndcLabelerCode: ''
    });
  }

  privateNdcCodeChanged(event) {

    if (event.target.value && this.ndcUserLabelerCodeBeforeSelectionChanged !== event.target.value) {
      this.confirmDialogNDC.show();
    }

    this.ndcProductCodeChangedObject['newNdcCode'] = event.target.value;
    this.ndcProductCodeChangedObject['oldNdcCode'] = this.ndcUserLabelerCodeBeforeSelectionChanged;

    this.ndcType = 'single';

    this.labelerForm.patchValue({
      ndcType: 'single',
      ndcLabelerCode: ''
    });
  }


  confirmDlgButtonsNDCClickYes: EmitType<object> = () => {

    this.ndcType = 'single';

    if (this.confirmDialogNDC) {

      this.confirmDialogNDC.hide();
    }

    if (!this.labelerForm.value.userNdcLabelerCode) {

      this.labelerCodeValue.emit(this.ndcLabelerCode ? this.ndcLabelerCode : (this.ndcDataSource[1] ? this.ndcDataSource[1]['name'] : ''));
      this.ndcDdw.value = this.ndcLabelerCode ? this.ndcLabelerCode : (this.ndcDataSource[1] ? this.ndcDataSource[1]['name'] : '');

      this.labelerForm.patchValue({
        lCompanyRevisionId: this.lCompanyRevisionId ? this.lCompanyRevisionId : this.labeler.companyRevisionId,
        ndcLabelerCode: this.ndcLabelerCode ? this.ndcLabelerCode : (this.ndcDataSource[1] ? this.ndcDataSource[1]['name'] : '')
      });

    } else {

      this.labelerCodeValue.emit(this.labelerForm.value.userNdcLabelerCode);
      this.ndcUserLabelerCodeBeforeSelectionChanged = this.labelerForm.value.userNdcLabelerCode;

      this.labelerForm.patchValue({
        lCompanyRevisionId: this.lCompanyRevisionId,
        userNdcLabelerCode: this.labelerForm.value.userNdcLabelerCode
      });


    }

    const changedCompany = this.labelerCompanies.find(c => c.companyRevisionId === this.lCompanyRevisionId);

    if (changedCompany) {
      this.llFormData[0].data.labelerCompany = changedCompany;
    }
  }

  confirmDlgButtonsNDCClickNo: EmitType<object> = () => {

    if (this.confirmDialogNDC) {

       this.confirmDialogNDC.hide();
      }

    if (!this.ndcUserLabelerCodeBeforeSelectionChanged) {
        this.ndcType = 'multi';
    }

    this.labelerForm.patchValue({
      ndcLabelerCode: this.labeler.ndcLabelerCode ? this.labeler.ndcLabelerCode : this.ndcCodeChangedObject['oldNdcCode'],
      userNdcLabelerCode: this.ndcUserLabelerCodeBeforeSelectionChanged,
      ndcType: this.ndcType
    });

    this.ndcDdw.value = this.ndcType === 'single' ? this.ndcUserLabelerCodeBeforeSelectionChanged : this.llFormData[0].data.ndcLabelerCode;

    this.ndcCodeChangedObject = {};
  }

  onTabPressed(event) {
    this.privateNdcCodeChanged(event);
}

   // eslint-disable-next-line @typescript-eslint/member-ordering
   confirmDlgButtonsNDC: Object[] = [{ click: this.confirmDlgButtonsNDCClickNo.bind(this), buttonModel: { content: 'Cancel' } }, { click: this.confirmDlgButtonsNDCClickYes.bind(this), buttonModel: { content: 'Continue', isPrimary: true } }];

    // Check if the previously saved company is the latest version
  isCompanyLatest(companyLov: any[], companyRevisionId: number) {

    if (companyRevisionId) {
      const company = companyLov.find(x => x.companyRevisionId === companyRevisionId);
      if (!company) {

        this.company$ = this.companyService.getCompanyById(companyRevisionId.toString());

        this.lCompanyRevisionId = companyRevisionId;
        // this.ndcLabelerCode = '';

        this.setChangedLabelerCompany();

        return false;
      }
    }

    return true;
  }

  showCompanyDialog(companyRevisionId?: number) {

    this.labelerForm.markAsDirty();
    // this.pageLoading = true;

       if (companyRevisionId) {

        const companyData$ = forkJoin([this.companyService.getBusinessCategories(false),
          this.companyService.getCountries(),
          this.companyService.getContacts(),
          this.refDataService.GetAllBusinessOperationQualifier(),
          this.companyService.getCompanyRevisionHistory(companyRevisionId),
          this.companyService.getBusinessOperationQualifierByCompany(companyRevisionId.toString()),
          this.companyService.getCompanyById(companyRevisionId.toString()),
          this.companyService.getNDCLabelerCodesByCompany(companyRevisionId.toString())]
      ).pipe(catchError(err => of(err)
        )).subscribe(data => {

          if (this.companyDetailsComponent) {

            this.companyDetailsComponent.companyData = data;
            this.companyDetailsComponent.companyRevisionId = companyRevisionId.toString();
            this.companyDetailsComponent.populateDataFromResolver();
            this.companyDetailsComponent.setButtons();
            this.companyDetailsComponent.getFormControlByName('status').patchValue('Active');
            this.companyDetailsComponent.checkUserPermission();
            this.companyDetailsComponent.ngAfterViewInit();
          }

          // this.pageLoading = false;
          this.companyDialog.show();
        });
    } else {
      const companyData = [];

      this.sub = this.companyService.getBusinessCategories(false).subscribe( busCat => {
        companyData[0] = busCat;

        this.sub = this.companyService.getCountries().subscribe( countries => {
          companyData[1] = countries;

          this.sub = this.companyService.getContacts().subscribe( contacts => {
            companyData[2] = contacts;

             this.refDataService.GetAllBusinessOperationQualifier().subscribe(busQual => {

              companyData[3] = busQual;

              if (this.companyDetailsComponent) {

                this.companyDetailsComponent.companyData = companyData;
                this.companyDetailsComponent.companyRevisionId = '';
                this.companyDetailsComponent.company = null;
                this.companyDetailsComponent.companyHistory_grid_data = [];
                this.companyDetailsComponent.populateDataFromResolver();
                this.companyDetailsComponent.setButtons();
                this.companyDetailsComponent.checkUserPermission();
                this.companyDetailsComponent.ngAfterViewInit();
               }

               // this.pageLoading = false;
               this.companyDialog.show();

             });
          });
        });
      },
        error => {
            this.toastr.error(error.message ? error.message : this.llFormService.GENERIC_ERROR_MSG);
        });
    }
  }

  modalCompany(newCompany) {

    this.setSavedLabelerCompany(newCompany.companyRevisionId);

    this.companyDialogCancelButtonClicked();
  }


  setSavedLabelerCompany(companyRevisionId: any) {
    let company;

    this.sub = this.llFormService.getLCompanyTypesByCustomerGuid(this.customerGuid).subscribe(response => {

      const companyTypes = response['data'];

      this.llFormData[2].data = companyTypes;
      this.labelerCompanies = companyTypes['labelers'];

      company = this.labelerCompanies.find(c => c.companyRevisionId === companyRevisionId);

      if (company) {

        this.companyDataSource = [];

        this.labelerForm.patchValue({
          companyDdw: companyRevisionId,
        });

        this.setCompaniesDdw();

        //this.companyDataSource.sort(this.compare);

        this.companyDdw.dataSource = this.companyDataSource;
        this.companyDdw.dataBind();
        this.companyDdw.refresh();

        this.companyDdw.value = companyRevisionId;

        this.setNDCddw(companyRevisionId);
      }
      this.cdref.detectChanges();
    },
      error => {
        this.toastr.error(error.message);
      });

    this.labelerForm.markAsDirty();
  }

  companyDialogCancelButtonClicked() {

    if (this.companyDetailsComponent) {

      this.companyDetailsComponent.companyForm.clearValidators();
    }
    this.companyDialog.hide();
  }

   compare(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.bame) {
      return 1;
    }
    return 0;
  }
}


